import "./style.css";

export const FieldError = ({
  fieldErr,
  validationConfig = {},
  errPatternMessage = "Pattern Error",
}) => {
  const getMessage = () => {
    if (!fieldErr) return "";

    const { type, message } = fieldErr;

    if (message) return message;

    switch (type) {
      case "required":
        return "To pole jest wymagane";
      case "minLength":
        return `Minimalna liczba znaków ${validationConfig?.minLength}`;
      case "pattern":
        return errPatternMessage;
      default:
        return "Unknown error type";
    }
  };

  return <span className="fieldError">{getMessage()}</span>;
};
